import { render, staticRenderFns } from "./view-descriptions.vue?vue&type=template&id=3f2d562a&"
import script from "./view-descriptions.vue?vue&type=script&lang=js&"
export * from "./view-descriptions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports